<div class="template-builder-container" [class.hidden]="!isActive">
    <ui-dialog size="small" [open]="isTemplateModalOpen" (closing)="closeTemplateModal()" header="discardChanges">
        <p>{{ 'performance.templates.changesWontSave' | translate }}</p>
        <ui-dialog-footer>
            <ui-button type="ghost" (click)="closeTemplateModal()">{{ 'cancel' | translate }}</ui-button>
            <ui-button type="danger" (click)="back()">{{ 'discard' | translate }}</ui-button>
        </ui-dialog-footer>
    </ui-dialog>
    <div class="ui basic segment">
        <a (click)="openTemplateModal()" class="back-button flex">
            <mat-icon svgIcon="chevronLeft" [matTooltip]="'back' | translate"></mat-icon>
            {{ 'back' | translate }}
        </a>

        <div class="toolkit">
            <div class="flex">
                <app-header title="performance.templates.templateBuilderTitle"></app-header>
            </div>
            <mat-divider class="margin-bottom-3"></mat-divider>
            <form class="form" #form="ngForm">
                <div class="field available-fields connected-sortable">
                    <div class="margin-bottom-2">
                        {{ 'performance.templates.toolkitDragAndDropQuestions' | translate }}
                    </div>
                    <div
                        *ngFor="let tool of toolkit; let index = index"
                        [attr.field-type]="tool.type"
                        [attr.field-index]="index"
                        (mouseup)="itemMouseUp($event)"
                        class="label toolkit-item"
                    >
                        <mat-icon class="toolkit-icon" [matTooltip]="tool.icon" svgIcon="{{ tool.icon }}"></mat-icon>
                        {{ templateQuestionLabel[tool.label] | translate }}
                    </div>
                    <div *ngIf="_fields.length">
                        <mat-divider class="margin-top-3 margin-bottom-3"></mat-divider>
                        <ui-button data-cy="save-button" size="full-width" (click)="save()" type="primary">
                            <span class="padding-x-9">{{ 'performance.templates.saveTemplate' | translate }}</span>
                        </ui-button>
                    </div>
                </div>
            </form>
        </div>

        <form class="sortable fields">
            <h2 class="header">{{ templateName | translate }}</h2>
            <ui-card
                *ngFor="let field of _fields; let index = index; trackBy: trackByFn"
                class="field toolkit-item"
                [attr.arr-index]="index"
                [attr.field-index]="field.index"
            >
                <div class="flex justify-space-between margin-bottom-3">
                    <div class="card-label font-medium">
                        {{ 'performance.templates.questionCardTitle' | translate: { index: field.index + 1 } }}
                    </div>
                    <div class="icons">
                        <mat-icon
                            *ngIf="showBuilderImprovements"
                            (click)="duplicateField(index + 1)"
                            svgIcon="copy"
                            [matTooltip]="'copy' | translate"
                            [attr.data-cy]="'template-duplicate-question-' + index"
                        ></mat-icon>
                        <mat-icon
                            *ngIf="showBuilderImprovements"
                            (click)="deleteField(index)"
                            class="margin-left-1"
                            svgIcon="trash"
                            [matTooltip]="'delete' | translate"
                        ></mat-icon>
                        <a *ngIf="!showBuilderImprovements" (click)="deleteField(index)">Delete</a>
                    </div>
                </div>
                <div class="margin-bottom-3">
                    <span>{{ 'performance.templates.questionLabel' | translate }}</span>
                    <div>
                        <mat-form-field class="width-full no-labels no-helpers">
                            <ui-rich-text
                                name="{{ field.id }}-{{ field.type }}"
                                height="100%"
                                [(ngModel)]="field.question"
                                [displayToolbar]="false"
                                placeholder="{{ 'performance.templates.enterQuestionPlaceholder' | translate }}"
                                required
                            >
                            </ui-rich-text>
                        </mat-form-field>
                    </div>
                </div>

                <ng-template [ngIf]="field.type === 'freeform'">
                    <textarea
                        readonly="readonly"
                        placeholder="{{ 'performance.templates.enterAnswerInTextboxPlaceholder' | translate }}"
                        class="freeform-text"
                    ></textarea>
                </ng-template>

                <ng-template [ngIf]="field.type === 'multiple'">
                    <div class="grouped fields radio">
                        <div
                            *ngFor="let choice of field.choices; let choiceIndex = index; trackBy: trackChoiceIndex"
                            class="field"
                        >
                            <div class="flex justify-space-between transparent input">
                                <div class="flex align-items-center flex-grow">
                                    <mat-icon svgIcon="unselectedRadio"></mat-icon>
                                    <input
                                        type="text"
                                        name="{{ field.id }}-{{ field.type }}-{{ choiceIndex }}"
                                        [(ngModel)]="field.choices[choiceIndex]"
                                        placeholder="{{ 'performance.templates.typeOptionPlaceholder' | translate }}"
                                    />
                                </div>
                                <mat-icon
                                    (click)="removeChoice(index, choiceIndex)"
                                    [matTooltip]="'delete' | translate"
                                    svgIcon="trash"
                                    class="trash"
                                ></mat-icon>
                            </div>
                        </div>
                        <div class="field margin-top-3">
                            <ui-button type="outline" (click)="addChoice(index)">
                                <mat-icon svgIcon="plus" [matTooltip]="'add' | translate"></mat-icon>
                                {{ 'performance.templates.addChoice' | translate }}
                            </ui-button>
                        </div>
                    </div>
                </ng-template>

                <ng-template [ngIf]="field.type === 'rating'">
                    <div class="ui star rating" data-rating="5" data-max-rating="10"></div>
                    <div class="rating-labels">
                        <span>{{ 'performance.templates.lowRating' | translate }}</span>
                        <span>{{ 'performance.templates.highRating' | translate }}</span>
                    </div>
                </ng-template>

                <ng-template [ngIf]="field.type === 'scale'">
                    <div class="agree-disagree-scale">
                        <div>
                            <mat-icon svgIcon="stronglyDisagree"></mat-icon>
                            <div class="label" [innerHTML]="'performance.templates.stronglyDisagree' | translate"></div>
                        </div>
                        <div>
                            <mat-icon svgIcon="somewhatDisagree"></mat-icon>
                            <div class="label" [innerHTML]="'performance.templates.somewhatDisagree' | translate"></div>
                        </div>
                        <div>
                            <mat-icon svgIcon="neitherAgreeNorDisagree"></mat-icon>
                            <div
                                class="label"
                                [innerHTML]="'performance.templates.neitherAgreeNorDisagree' | translate"
                            ></div>
                        </div>
                        <div>
                            <mat-icon svgIcon="somewhatAgree"></mat-icon>
                            <div class="label" [innerHTML]="'performance.templates.somewhatAgree' | translate"></div>
                        </div>
                        <div>
                            <mat-icon svgIcon="stronglyAgree"></mat-icon>
                            <div class="label" [innerHTML]="'performance.templates.stronglyAgree' | translate"></div>
                        </div>
                    </div>
                </ng-template>

                <ng-template [ngIf]="field.type === 'boolean'">
                    <div class="true-false-scale">
                        <div>
                            <mat-icon svgIcon="thumbDown"></mat-icon>
                            <div class="label">{{ 'performance.templates.noDisagree' | translate }}</div>
                        </div>
                        <div>
                            <mat-icon svgIcon="thumbUp"></mat-icon>
                            <div class="label">{{ 'performance.templates.yesAgree' | translate }}</div>
                        </div>
                    </div>
                </ng-template>

                <mat-divider></mat-divider>
                <mat-checkbox
                    *ngIf="showBuilderImprovements"
                    [(ngModel)]="field.isOptional"
                    name="{{ index }}-isOptional"
                >
                    {{ 'performance.templates.optionalQuestion' | translate }}
                </mat-checkbox>
            </ui-card>

            <div *ngIf="!_fields.length">
                <div class="emptyLayout">
                    <mat-icon svgIcon="addElement" [matTooltip]="'add' | translate"></mat-icon>
                    <h4 [innerHTML]="'performance.templates.drapDropElementsFromToolkit' | translate"></h4>
                </div>
            </div>
        </form>
    </div>
</div>
